<ng-container *ngIf="environmentValue">
<ttl-header
  (ttlHeaderEvent)="onHeaderEventFire($event)"
  show-toggle-menu="false"
  show-customer-switch="true"
  header-size="small"
  env="{{environmentValue}}"
>
</ttl-header>
</ng-container>
